/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { getClientEmailsData } from 'state/actions/reportsState/reports_status';
// component
import AddableEmailList from 'material/addableemaillist/addableemaillist';



/* ========== ~~~~~~~~~~ ADDABLE EMAIL LIST : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({reportsState, sessionStatus}) => ({
    userEmail: sessionStatus.userEmail,
    allUsers: reportsState.reportsStatus.clientEmails.map((item, i)=> ({name: item.email, value: item.email})),
    usersPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.users'),
    accountUUID: sessionStatus.accountUUID
});

// map state
const mapDispatchToProps = dispatch => ({
    getUsers: (accountUUID) => dispatch(getClientEmailsData(accountUUID)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddableEmailList);
